import Model from 'flarum/common/Model';

export default class CustomFlagReason extends Model {
  constructor(...args) {
    super(...args);
  }
}

Object.assign(CustomFlagReason.prototype, {
  name: Model.attribute('name'),
  description: Model.attribute('description'),
  isActive: Model.attribute('isActive'),
  sortOrder: Model.attribute('sortOrder'),
  createdAt: Model.attribute('createdAt', Model.transformDate),
  updatedAt: Model.attribute('updatedAt', Model.transformDate)
}); 